import { render } from "./ReturnForm.vue?vue&type=template&id=8fc3288c&scoped=true"
import script from "./ReturnForm.vue?vue&type=script&lang=js"
export * from "./ReturnForm.vue?vue&type=script&lang=js"

import "./ReturnForm.vue?vue&type=style&index=0&id=8fc3288c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fc3288c"]])

export default __exports__